import Lightbox from 'vue-simple-lightbox';

import template from './gallery.vhtml';

export default {
	name: 'gallery',
	template,
	components: {
		Lightbox,
	},
	props: {
		imageArray: {
			type: String,
			required: true,
		},
		btnLabel: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			images: this.imageArray,
			options: {
				closeText: '&times;',
				showCounter: false,
			},
		};
	},
	computed: {
		lightBoxImages() {
			const images = JSON.parse(this.images);
			const imagesWithKeys = [];
			for (const image of images) {
				imagesWithKeys.push({src: image.resized});
			}
			return imagesWithKeys;
		},
		firstImage() {
			const firstImage = this.lightBoxImages[0];
			return firstImage.src;
		},
		lastImages() {
			const lastImages = this.lightBoxImages.slice(1);
			return lastImages;
		}
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/gallery/gallery.js